import { render } from "./sharecodeChannelEdit.vue?vue&type=template&id=2b0793e4"
import script from "./sharecodeChannelEdit.vue?vue&type=script&lang=js"
export * from "./sharecodeChannelEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/components/sharecodeChannelEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b0793e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b0793e4', __exports__)) {
    console.log('reload')
    api.reload('2b0793e4', __exports__)
  }
  
  module.hot.accept("./sharecodeChannelEdit.vue?vue&type=template&id=2b0793e4", () => {
    console.log('re-render')
    api.rerender('2b0793e4', render)
  })

}


export default __exports__